import BtnLink from '@/components/BtnLink'
import injectSheet from 'react-jss'
import style from './style'

const Highlights = ({
  classes,
  title,
  text,
  items,
  link,
  label,
}) => {
  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        <div className={classes.container}>
          <div className={classes.intro}>
            <h2
              className={classes.title}
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <div
              className={classes.text}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </div>
          <div className={classes.grid}>
            {items.map((item, i) => (
              <div
                className={classes.gridItem}
                key={i.toString()}
              >
                <div className={classes.gridItemHeader}>
                  <span>{item.number}</span>
                  <svg><use xlinkHref={`#${item.icon}`} /></svg>
                </div>
                <div className={classes.gridItemFooter}>
                  {item.text}
                </div>
              </div>
            ))}
          </div>
          {link && (
            <div className={classes.btnContainer}>
              <BtnLink
                link={link}
                label={label}
                theme="orange"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default injectSheet(style)(Highlights)
